import { render, staticRenderFns } from "./StateAnswerAccepted.vue?vue&type=template&id=19cb2d5a&scoped=true&lang=html&"
import script from "./StateAnswerAccepted.vue?vue&type=script&lang=js&"
export * from "./StateAnswerAccepted.vue?vue&type=script&lang=js&"
import style0 from "./StateAnswerAccepted.vue?vue&type=style&index=0&id=19cb2d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cb2d5a",
  null
  
)

component.options.__file = "StateAnswerAccepted.vue"
export default component.exports